import { render, staticRenderFns } from "./35.vue?vue&type=template&id=1619bf6a&scoped=true&"
var script = {}
import style0 from "./35.vue?vue&type=style&index=0&id=1619bf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1619bf6a",
  null
  
)

export default component.exports